<template>
	<section id="farewell">
		<section id="farewell-message">
			<div class="container-sm is-centered">
				<h1>Farewell friends!</h1>
				<p>Saying goodbye is never easy, especially when it's to a group of people as awesome as you. Over the years, we've laughed together, we've worked our asses off together, and most importantly: we've suffered through Sean's dad jokes together. I have made many fond memories with this team, and will miss y'all sorely. You will see below that I've put together a short bio on each of you based on our time together.</p>
				<p>Please feel free to reach out if you want to play board games, want to learn how to play D&D, or you need someone to keep Sean in check with sass (although I think you've got that covered pretty well).</p>
				<p class="is-sm">P.S. If you don't approve of the photo I chose for you, too bad! (*insert evil laugh*) This is what happens when you leave things lying around on the internet!</p>
				<p class="is-sm">P.P.S. Now that Susie is moving downtown, she should have ample free time to handle the team's baking orders in my stead. She's really good at baking, so go ahead and bug her constantly.</p>
			</div>
		</section>
		<div class="container-lrg is-centered center-align">
			<ul id="friends-list">
				<li v-for="person in people">
					<router-link :to="{ name: 'Friend', params: { id: person.Name }}">
						<img :src="'/img/rl-team-photos/' + person.Photo" :alt="person.Name" :title="person.Name"/>
						<span>{{person.Name}}</span>
					</router-link>
				</li>
			</ul>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Farewell',
	data() {
		return {
			people: [],
		}
	},
	mounted() {
		const vm = this;
		fetch(process.env.BASE_URL + 'json/rl-friends.json')
		.then(
			function(response) {
				if (response.status !== 200) {
					console.log('Looks like there was a problem. Status Code: ' + response.status);
					return;
				}

				// Examine the text in the response
				response.json().then(function(data) {
					vm.people = data;
				});
			}
		)
		.catch(function(err) {
			console.log('Fetch Error :-S', err);
		});
	}
}
</script>

<style lang="scss">
// @import 'src/assets/css/modules/colors';

#farewell-message {
	padding: 6rem 0 4rem;
	p {
		font-size: 1.125rem;
		line-height: 1.6;
	}
	.is-sm {
		font-size: 0.75rem;
	}
}

@keyframes tick-tock {
  0%   {transform: rotateZ(-15deg)}
  50% {transform: rotateZ(15deg)}
}

#friends-list {
	list-style: none;
	padding: 0;
	margin: 0;
	li {
		display: inline-block;
		margin: 0 1rem 2rem;
	}
	a {
		&:hover, &:focus {
			animation: tick-tock 0.6s step-end infinite;
			display: block;
			img {
				border-color: #45A838;
				box-shadow: 0 0 10px 6px rgba(0,0,0,0.5);
			}
		}
	}
	img {
		border-radius: 50%;
		border: 5px solid #434343;
		display: inline-block;
		height: 160px;
		width: 160px;
	}
	span {
		display: block;
		margin: 0.5rem 0 0;
		font-weight: bold;
		font-size: 1.125rem;
	}
}
</style>